<div *ngIf="isLoading">
  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  Loading Configurations...
</div>

<div *ngIf="!isLoading">
  <h5>
    <a href="javascript:;" class="btn btn-sm btn-outline-primary btn-round btn-icon" (click)="onAddNewEmail()"
      data-toggle="modal" data-target="#mdlEmailConfiguration"><i class="nc-icon nc-simple-add"></i></a>
    Email's Configurations
  </h5>
  <div *ngIf="emailConfigs">
    <div class="table-responsive">
      <table class="table">
        <thead class=" text-primary">
          <th>
            Email
          </th>
          <th>
            Smtp Server
          </th>
          <th>
            Port
          </th>
          <th>
            Templates
          </th>
          <th class="text-right">
            ...
          </th>
        </thead>
        <tbody>
          <tr *ngFor="let itm of emailConfigs">
            <td>
              {{itm.fromEmail}}
            </td>
            <td>
              {{itm.smtpServer}}
            </td>
            <td>
              {{itm.port}}
            </td>
            <td>
              {{itm.templates}}
            </td>
            <td class="text-right">
              <a href="javascript:;" (click)="onEditEmailConfig(itm)" data-toggle="modal"
                data-target="#mdlEmailConfiguration" class="btn btn-sm btn-outline-info btn-round btn-icon"><i
                  class="fa fa-pencil"></i></a>
              <a href="javascript:;" (click)="onShowTemplates(itm)"
                class="btn btn-sm btn-outline-info btn-round btn-icon ml-1"><i class="fa fa-file"></i></a>
              <a href="javascript:;" (click)="onClientConfig(itm)" data-toggle="modal" data-target="#mdlClientConfig"
                class="btn btn-sm btn-outline-info btn-round btn-icon ml-1"><i class="fa fa-gear"></i></a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Modal: Client Configuration -->
<div class="modal fade" id="mdlClientConfig" tabindex="-1" role="dialog" aria-labelledby="mdlClientConfigLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-md" role="document">
    <div class="modal-content" style="display: flex; flex-direction: column;">
      <div class="modal-header">
        <h5 class="modal-title" id="mdlClientConfigLabel">Client Configuration</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p class="text-muted mb-2"><small>Copia esta estructura y úsala para configurar el cliente:</small></p>
        <div style="font-family: monospace; font-size: 12px; height: 400px; overflow-y: auto; background: #f8f9fa; border: 1px solid #dee2e6; border-radius: 4px; padding: 10px; white-space: pre-wrap; word-break: break-word;">{{clientConfigJson}}</div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>